import React from 'react';

import {Helmet} from 'views/module';
import AgentChatScene from 'views/scenes/agent/AgentChatScene';

const AgentChat = () => (
  <>
    <Helmet>
      <title>Quilt: Agent Chat</title>
    </Helmet>
    <AgentChatScene />
  </>
);

export default AgentChat;
